<template>
  <one-column-layout class="dark space-l">
    <title-bar title="Admin Dashboard" slot="titleBar" type="page" />

    <div class="toolbar" slot="subtitleBar">
      <smd-segment type="pill"
                   :items="$options.Views"
                   v-model="activeView"></smd-segment>

      <div class="smd-spacer"></div>

    </div>

    <div>
      <transition name="fade" :duration="{enter: 500, leave : 100}">
        <router-view name="admin"/>
      </transition>
    </div>

  </one-column-layout>
</template>

<script>

  import Routes from '../../../router/route-constants'

  export default {
    name: "root-submissions",
    data(){
      return{
        activeView   : this.$route.name,
      }
    },
    Views: [
      {val: Routes.ROUTE_USERS, label: 'Users'},
      {val: Routes.ROUTE_ROLES, label: 'Roles'}
    ],
    watch:{
      activeView: function(){
        this.$router.push({name: this.activeView})
      }
    },
  }
</script>

<style scoped>

</style>
